// extracted by mini-css-extract-plugin
module.exports = {"matrix-table--pad3":"l_t ml-3","matrix-table--pad4":"l_v ml-5","matrix-table__title":"l_w","matrix-table__true":"l_x","matrix-table__false":"l_y"};